"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_converged__proposition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a0f67581-eccb-4753-83dc-069c5d963cbd",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bd241e19-5b66-4cba-8114-126301946d16{fill:#ebebeb;}.b1af8456-a961-40ba-be21-f0e1c89b06a1,.b2b400a1-55ff-409b-9746-d84e1037fd12{opacity:0.06;}.a0f45647-d6e8-4d12-b20a-33f5950e1ae5,.ad6e902f-cac6-4df2-86f5-abf7bd5d9d79,.b1af8456-a961-40ba-be21-f0e1c89b06a1,.b9ac36d0-133f-4074-aed8-c22fc6f08f52,.fe4e7830-b58e-4450-85f0-df72c59d4cd1{isolation:isolate;}.a420ef9f-d038-464d-957d-6c968fd5a51f{fill:#333;}.ad6e902f-cac6-4df2-86f5-abf7bd5d9d79,.fe4e7830-b58e-4450-85f0-df72c59d4cd1{opacity:0.2;}.ad6e902f-cac6-4df2-86f5-abf7bd5d9d79{fill:url(#e92951b4-690f-402a-ba49-c51cfb6bd2f4);}.a0f45647-d6e8-4d12-b20a-33f5950e1ae5,.b9ac36d0-133f-4074-aed8-c22fc6f08f52{opacity:0.5;}.b9ac36d0-133f-4074-aed8-c22fc6f08f52{fill:url(#b348f5aa-81cc-4369-bc32-7ad143ae0b99);}.ff313d64-7e38-4461-812e-9e2f1077015d{fill:none;}.ac2a97ef-d0d2-463f-b8bd-28a10a77098f{fill:#e60000;}.a8bd0b4c-ad1b-449a-a8f5-d23556855aa9{fill:#4a4d4e;}.b74bf280-5c7a-4e76-99f3-c8a214382e9f{fill:#fff;}.a0f45647-d6e8-4d12-b20a-33f5950e1ae5,.fe4e7830-b58e-4450-85f0-df72c59d4cd1{fill:url(#e9461b70-a04a-4a8b-9637-dc429dd61213);}.f280fcd9-cfcc-4fa6-9b05-aa6c0c05159a{opacity:0.24;}.f9ad7755-9959-4c46-8488-45b25f738cc8{fill:#f4f4f4;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e92951b4-690f-402a-ba49-c51cfb6bd2f4",
    x1: 3528.98,
    y1: -5301.19,
    x2: 3528.98,
    y2: -5323.87,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -6152.98, -1122.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b348f5aa-81cc-4369-bc32-7ad143ae0b99",
    x1: 42.01,
    y1: -432.05,
    x2: 150.01,
    y2: -540.04,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e9461b70-a04a-4a8b-9637-dc429dd61213",
    x1: 127.29,
    y1: -497.29,
    x2: 180.71,
    y2: -550.71,
    xlinkHref: "#b348f5aa-81cc-4369-bc32-7ad143ae0b99"
  })), /*#__PURE__*/React.createElement("title", null, "converged-proposition-hi"), /*#__PURE__*/React.createElement("g", {
    id: "ba9a0b7c-4f2c-486e-9cea-313d8e62f026",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bd241e19-5b66-4cba-8114-126301946d16",
    x: 24,
    y: 40.06,
    width: 144,
    height: 95.94,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1af8456-a961-40ba-be21-f0e1c89b06a1",
    d: "M164,134.06H28a4,4,0,0,1-4-4V132a4,4,0,0,0,4,4H164a4,4,0,0,0,4-4v-1.94A4,4,0,0,1,164,134.06Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a420ef9f-d038-464d-957d-6c968fd5a51f",
    x: 26,
    y: 42.06,
    width: 139.99,
    height: 83.94,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "a420ef9f-d038-464d-957d-6c968fd5a51f",
    points: "163.99 124.06 28 124 28 44.06 163.99 44.06 163.99 124.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd241e19-5b66-4cba-8114-126301946d16",
    d: "M70,150.06h0A2,2,0,0,1,71.94,148h48.13a2,2,0,0,1,1.94,2.06h0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bd241e19-5b66-4cba-8114-126301946d16",
    x: 86,
    y: 136.06,
    width: 19.99,
    height: 11.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd241e19-5b66-4cba-8114-126301946d16",
    d: "M122,150v2H70v-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b1af8456-a961-40ba-be21-f0e1c89b06a1",
    x: 69.99,
    y: 150,
    width: 52,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b1af8456-a961-40ba-be21-f0e1c89b06a1",
    x: 86,
    y: 136.06,
    width: 19.99,
    height: 11.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ad6e902f-cac6-4df2-86f5-abf7bd5d9d79",
    points: "105.99 148 97.87 148.12 85.83 136.08 105.99 136 105.99 148"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b9ac36d0-133f-4074-aed8-c22fc6f08f52",
    points: "163.99 124.06 28 124 28 44.06 163.99 44.06 163.99 124.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd241e19-5b66-4cba-8114-126301946d16",
    d: "M53.49,142l7.95-3c2-.39,3.82-.11,4.71.84,1.34,1.44,12.4,14.25,13.32,15.37s.8,3.53-1.44,5.28-12.14,8.38-15.2,7.4S47,163,29.77,132.36,16,89.15,16.82,86.11s11.87-7.59,14.59-8.48,4.87.35,5.35,1.66c.55,1.5,5.59,17.39,6.12,19.2.37,1.24-.4,2.9-1.81,4.32S34,109.55,34,109.55s1.33,5.16,7.69,16.45C44.7,131.45,53.49,142,53.49,142Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ff313d64-7e38-4461-812e-9e2f1077015d",
    d: "M53.49,142h0l-.13-.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac2a97ef-d0d2-463f-b8bd-28a10a77098f",
    d: "M35.84,107.83c-1.55-5-6-19.11-9-28.38-.66.29-1.35.6-2,.93C28,90.49,33,106.12,34,109.54Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd241e19-5b66-4cba-8114-126301946d16",
    d: "M53.37,141.9l-.07-.08h0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac2a97ef-d0d2-463f-b8bd-28a10a77098f",
    d: "M55.72,141.2l-2.22.8c2.34,2.55,11.32,12.92,19.18,22,.66-.4,1.3-.81,1.9-1.19C67.19,154.32,58.75,144.57,55.72,141.2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b2b400a1-55ff-409b-9746-d84e1037fd12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,107.55s.13.5.5,1.53c1.41-1.33,5.42-5.1,6.57-6.27,1.41-1.41,2.17-3.08,1.81-4.32l-.09-.31a6.89,6.89,0,0,1-1.71,2.63C39.68,102.23,34,107.55,34,107.55Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,158.5c-2.24,1.75-12.14,8.38-15.2,7.4s-15.8-4.9-33-35.54C18.8,110.87,16.24,98.68,16,91.61c-.22,6.67,1.67,19.28,13.75,40.75C47,163,59.75,166.92,62.8,167.9s13-5.65,15.2-7.4a4.25,4.25,0,0,0,1.81-4.57A5,5,0,0,1,78,158.5Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "bd241e19-5b66-4cba-8114-126301946d16",
    x: 132,
    y: 80,
    width: 44,
    height: 88,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1af8456-a961-40ba-be21-f0e1c89b06a1",
    d: "M172,166H136a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4h36a4,4,0,0,0,4-4v-2A4,4,0,0,1,172,166Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a8bd0b4c-ad1b-449a-a8f5-d23556855aa9",
    x: 151,
    y: 84,
    width: 8,
    height: 1,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac2a97ef-d0d2-463f-b8bd-28a10a77098f",
    x: 148,
    y: 84,
    width: 1,
    height: 1,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ac2a97ef-d0d2-463f-b8bd-28a10a77098f",
    cx: 154,
    cy: 161,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "b74bf280-5c7a-4e76-99f3-c8a214382e9f",
    d: "M86.5,100.92a2,2,0,0,1-1.41-3.41,15.5,15.5,0,0,1,21.82-.05,2,2,0,0,1-2.81,2.84,11.49,11.49,0,0,0-16.18,0A2,2,0,0,1,86.5,100.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b74bf280-5c7a-4e76-99f3-c8a214382e9f",
    d: "M115.07,88.92a2,2,0,0,1-1.37-.54l-.08-.08a25,25,0,0,0-35.25,0,2,2,0,0,1-2.83-2.83,29,29,0,0,1,40.9,0,2,2,0,0,1-1.37,3.44Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "be0e4623-cabe-476c-83cb-1bb083130562",
    "data-name": "f50f5723-86e8-4cc0-a628-9ec63511e94b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b74bf280-5c7a-4e76-99f3-c8a214382e9f",
    d: "M124.53,76.88a2,2,0,0,1-1.41-.58,38.47,38.47,0,0,0-54.23,0,2,2,0,1,1-2.82-2.84h0a42.48,42.48,0,0,1,59.88.05,2,2,0,0,1-1.41,3.42Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "ff313d64-7e38-4461-812e-9e2f1077015d",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a420ef9f-d038-464d-957d-6c968fd5a51f",
    x: 134,
    y: 88,
    width: 40,
    height: 68,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a0f45647-d6e8-4d12-b20a-33f5950e1ae5",
    x: 134,
    y: 88,
    width: 40,
    height: 68,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fe4e7830-b58e-4450-85f0-df72c59d4cd1",
    x: 134,
    y: 88,
    width: 40,
    height: 68,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    className: "f280fcd9-cfcc-4fa6-9b05-aa6c0c05159a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a420ef9f-d038-464d-957d-6c968fd5a51f",
    d: "M173,89v66H135V89h38m0-1H135a1,1,0,0,0-1,1v66a1,1,0,0,0,1,1h38a1,1,0,0,0,1-1V89A1,1,0,0,0,173,88Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b2b400a1-55ff-409b-9746-d84e1037fd12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a420ef9f-d038-464d-957d-6c968fd5a51f",
    d: "M86.5,100.92a2,2,0,0,1-1.41-3.41,15.5,15.5,0,0,1,21.82-.05,2,2,0,0,1-2.81,2.84,11.49,11.49,0,0,0-16.18,0A2,2,0,0,1,86.5,100.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a420ef9f-d038-464d-957d-6c968fd5a51f",
    d: "M115.07,88.92a2,2,0,0,1-1.37-.54l-.08-.08a25,25,0,0,0-35.25,0,2,2,0,0,1-2.83-2.83,29,29,0,0,1,40.9,0,2,2,0,0,1-1.37,3.44Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a420ef9f-d038-464d-957d-6c968fd5a51f",
    d: "M124.53,76.88a2,2,0,0,1-1.41-.58,38.47,38.47,0,0,0-54.23,0,2,2,0,1,1-2.82-2.84h0a42.48,42.48,0,0,1,59.88.05,2,2,0,0,1-1.41,3.42Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "f9ad7755-9959-4c46-8488-45b25f738cc8",
    cx: 96,
    cy: 110,
    r: 4
  })));
}

var _default = ic_converged__proposition;
exports.default = _default;